import { TableRow } from '@material-ui/core';
import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles';

const ESTADO_CONFIG = {
    BORRADOR:  { label: 'Borrador',  color: '#6c757d' },
    PUBLICADO: { label: 'Publicado', color: '#28a745' },
    CERRADO:   { label: 'Cerrado',   color: '#343a40' },
};

const ProgramasPreventivosGridRow = (props) => {
    const programa = props.programa;
    const permissions = props.permissions;
    const baseUrl = props.baseUrl;
    const [redirectTo, setRedirectTo] = useState(null);

    const estadoCfg = ESTADO_CONFIG[programa.estado] || { label: programa.estado, color: '#6c757d' };

    return (
        <>
            {redirectTo && <Redirect push to={redirectTo} />}
            <TableRow hover>
                <StyledTableCell align="left">
                    {programa.nombre}
                </StyledTableCell>
                <StyledTableCell align="left">
                    {programa.fecha_inicio} → {programa.fecha_fin}
                </StyledTableCell>
                <StyledTableCell align="left">
                    <span style={{
                        backgroundColor: estadoCfg.color,
                        color: '#fff',
                        borderRadius: '4px',
                        padding: '2px 10px',
                        fontSize: '12px',
                        fontWeight: 500,
                    }}>
                        {estadoCfg.label}
                    </span>
                </StyledTableCell>
                <StyledTableCell align="center">
                    {programa.vehiculos_incluidos}
                </StyledTableCell>
                <StyledTableCell align="center">
                    {programa.vehiculos_excluidos}
                </StyledTableCell>
                <StyledTableCell align="left">
                    {programa.updated_at}
                </StyledTableCell>
                <StyledTableCell align="center">
                    <div className="d-inline-flex">
                        {permissions.visualizar && (
                            <button
                                className="action view btn btn-sm btn-icon btn-dt-grid text-success"
                                title="Ver"
                                data-toggle="tooltip"
                                data-placement="top"
                                onClick={() => setRedirectTo(baseUrl + '/' + programa.id)}
                            >
                                <i className="fa fa-search fa-xs" />
                            </button>
                        )}
                    </div>
                </StyledTableCell>
            </TableRow>
        </>
    );
};

export default ProgramasPreventivosGridRow;
